<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ oopt.transName }} > {{ $t('Заявки на квоты') }} > {{ $t('Создание') }}</h1>
    <div class="my-organization">
      <div class="create-quota-pg bgw-pdg-20">
        <h4 class="text-center">{{ $t('Заявка на квоты на добычу диких животных') }} {{ oopt.transName }}</h4>
        <v-form
          ref="form"
          lazy-validation
          enctype="multipart/form-data"
          @submit.prevent="createQuotaApplication"
        >
          <div class="form-group">
            <div class="quota-fields">
              <div class="quota-field" :class="{ invalid: $v.quota_application.number.$error }">
                <label>{{ $t('Исх. номер') }}:</label>
                <v-text-field
                  v-model="quota_application.number"
                  outlined
                  dense
                  class="size-small"
                />
              </div>
              <div class="quota-field datepicker-main" :class="{ invalid: $v.quota_application.date.$error }">
                <label>{{ $t('Дата') }}:</label>
                <div class="form-date">
                  <v-icon class="date-icon">date_range</v-icon>
                  <VueCtkDateTimePicker
                    id="DatePicker"
                    v-model="quota_application.date"
                    format="DD.MM.YYYY"
                    formatted="LL"
                    :onlyDate="true"
                    :label="$t('Дата')"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    :autoClose="true"
                    :noButton="true"
                  />
                </div>
              </div>
              <div class="quota-field" :class="{ invalid: $v.quota_application.stateDuty.$error }">
                <label>{{ $t('Госпошлина в сомах') }}:</label>
                <v-text-field
                  v-model="quota_application.stateDuty"
                  type="number"
                  outlined
                  dense
                  class="size-small hide-arrows"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="quota-fields fauna-fields" v-for="(item, index) in faunaQuota" :key="index">
              <div class="quota-field">
                <div class="select-def" :class="{ invalid: $v.faunaQuota.$each[index].fauna.$error }">
                  <v-select
                    :items="faunas"
                    item-value="id"
                    item-text="transName"
                    return-object
                    v-model="item.fauna"
                    outlined
                    dense
                    required
                    clearable
                  />
                </div>
                <div class="quota-limit" v-if="item.fauna">
                  <span v-if="item.fauna.limitHeadQuantity">{{ $t('Лимит') }} <strong>{{ item.fauna.limitHeadQuantity }}</strong></span>
                </div>
              </div>
              <div class="quota-field" :class="{ invalid: $v.faunaQuota.$each[index].count.$error }">
                <label>{{ $t('Количество гол.') }}</label>
                <v-text-field
                  v-model="item.count"
                  type="number"
                  outlined
                  dense
                  class="size-small"
                />
                <v-btn class="btn-add" @click.native.stop="deleteFaunaItem(index)">
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </div>
            </div>
            <v-btn
              class="btn-add btn-add-small"
              @click.native.stop="addFaunaItem()"
            >
              <img src="@/assets/img/plus-icon.png" alt="icon">
              {{ $t('Добавить животное') }}
            </v-btn>
          </div>
          <div class="form-group">
            <!--Документы-->
            <div class="quota-bottom">
              <Documents v-bind:documents.sync="documents" :editable="true" :quotaApplicationId="quota_application.id"/>
            </div>
          </div>
          <div class="form-action">
            <button
              class="btn btn-default blue"
              type="submit"
              @click="statusId = filledStatus"
            >
              {{ $t('Сохранить') }}
            </button>
            <button
              class="btn btn-default blue"
              type="submit"
              @click="statusId = sentStatus"
            >
              {{ $t('Сохранить и отправить') }}
            </button>
            <button
              class="btn btn-default gray"
              type="button"
              @click="onCancel"
            >
              {{ $t('Отмена') }}
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Quota from '@/model/quota'
import { required } from 'vuelidate/lib/validators'
import Documents from '@/components/quota/Documents'

export default {
  components: {
    Documents
  },
  data: () => ({
    breadcrumbs: [],
    quota_application: {},
    oopt: [],
    faunas: [],
    documents: [],
    filledStatus: null,
    sentStatus: null,
    statusId: null,
    faunaQuota: [{
      fauna: null,
      count: null
    }]
  }),
  validations: {
    quota_application: {
      number: { required },
      date: { required },
      stateDuty: { required }
    },
    faunaQuota: {
      $each: {
        fauna: { required },
        count: { required }
      }
    }
  },
  computed: {
    minDate () {
      const year = new Date().getFullYear()
      return year + '-01-01'
    },
    maxDate () {
      const year = new Date().getFullYear()
      return year + '-12-31'
    }
  },
  mounted () {
    this.getQuotaFormData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные для формы
    getQuotaFormData () {
      this.setLoading(true)
      Quota.getQuotaApplicationFormData(this.$route.params.id)
        .then((response) => {
          this.oopt = response.data.oopt
          this.faunas = response.data.faunas
          this.filledStatus = response.data.filledStatus
          this.sentStatus = response.data.sentStatus
          this.generateBreadcrumbs()
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.setLoading(false)
        })
    },
    createQuotaApplication () {
      if (!this.validateForm()) {
        return
      }

      const formEl = this.$refs.form.$el
      const formData = new FormData(formEl)

      formData.append('quota_application[number]', this.quota_application.number)
      formData.append('quota_application[date]', this.quota_application.date)
      formData.append('quota_application[stateDuty]', this.quota_application.stateDuty)
      // Добавление документов
      this.documents.forEach(function (element, index) {
        formData.append(`quota_application[quotaApplicationDocuments][${index}][uploadedFile]`, element.file)
        formData.append(`quota_application[quotaApplicationDocuments][${index}][description]`, element.description)
        formData.append(`quota_application[quotaApplicationDocuments][${index}][type]`, element.type)
      })
      // Добавление видов животных и проверка на дублирование
      const faunaIds = []
      this.faunaQuota.forEach(function (element, index) {
        faunaIds.push(element.fauna.id)
        formData.append('quota_application[faunaQuotas][' + index + '][fauna]', element.fauna.id)
        formData.append('quota_application[faunaQuotas][' + index + '][count]', element.count)
      })
      const filterFaunaIds = faunaIds.filter((v, i, a) => a.indexOf(v) === i)
      if (filterFaunaIds.length !== faunaIds.length) {
        this.$noty.error(this.$i18n.t('Внимание! В форме выбраны повторяющиеся виды животных.'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        return
      }

      this.setLoading(true)
      Quota.createQuotaApplication(this.$route.params.id, this.statusId, formData).then((response) => {
        this.$router.push({
          name: 'society-quota-applications',
          params: {
            id: this.$route.params.id
          }
        })
        this.setLoading(false)
      }).catch((error) => {
        let msg = error.message
        if (error.response) {
          if (error.response.data.form) {
            msg = this.$i18n.t(error.response.data.form.message)
          } else if (error.response.data.message) {
            msg = this.$i18n.t(error.response.data.message)
          }
        }
        this.$noty.error(msg, {
          killer: true,
          timeout: 2000,
          layout: 'topRight'
        })
        this.setLoading(false)
      })
    },
    // добавляем доп поле для животных
    addFaunaItem () {
      this.faunaQuota.push({
        fauna: null,
        count: null
      })
    },
    // удаляем доп поле из списка животных
    deleteFaunaItem (index) {
      this.faunaQuota.splice(index, 1)
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Заявки на квоты'),
          disabled: false,
          href: `/society/quota-applications/${this.$route.params.id}`
        },
        {
          text: this.$i18n.t('Создание'),
          disabled: true
        }
      ]
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'society-quota-applications',
        params: {
          id: this.$route.params.id
        }
      })
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langNpaTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
.form-group .quota-fields:first-child .btn-add {
  display: none;
}

.form-group .quota-fields .btn-add {
  margin-left: 10px;
  color: red;
}

.fauna-fields {
  margin-bottom: 20px;
}

.select-def {
  max-width: 260px;
}
</style>
